import {
	hcGetCrqsToCreateRequest, hcGetCrqsToCreateSuccess, hcGetCrqsToCreateFailure,
	hcGetCrqsOnQueueWithErrorRequest, hcGetCrqsOnQueueWithErrorSuccess, hcGetCrqsOnQueueWithErrorFailure,
	hcCrqsToCreateActionRequest, hcCrqsToCreateActionSuccess, hcCrqsToCreateActionFailure,
	hcCrqsOnQueueWithErrorActionRequest, hcCrqsOnQueueWithErrorActionSuccess, hcCrqsOnQueueWithErrorActionFailure,
} from './HelixCrqsActions';
import {
	HelixCreationsGetCrqsToCreateRequest,
	HelixCreationsGetCrqsOnQueueWithErrorRequest,
	HelixCrqsToCreateActionRequest,
	HelixCrqsOnQueueWithErrorActionRequest,
} from '../Requests/HelixCrqsRequests';

// ─── CREATIONS — initial load (shows loading spinner) ─────────────────────────

export const hcGetCrqsToCreate = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToCreateRequest());
	await HelixCreationsGetCrqsToCreateRequest(history).then((response) => {
		dispatch(hcGetCrqsToCreateSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToCreateFailure(error?.message));
	});
};

export const hcGetCrqsOnQueueWithError = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsOnQueueWithErrorRequest());
	await HelixCreationsGetCrqsOnQueueWithErrorRequest(history).then((response) => {
		dispatch(hcGetCrqsOnQueueWithErrorSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsOnQueueWithErrorFailure(error?.message));
	});
};

// ─── CREATIONS — silent poll (no loading flag, no flicker) ────────────────────

export const hcPollCrqsToCreate = (history = false) => async (dispatch) => {
	await HelixCreationsGetCrqsToCreateRequest(history).then((response) => {
		dispatch(hcGetCrqsToCreateSuccess(response.data ?? []));
	}).catch(() => {});
};

export const hcPollCrqsOnQueueWithError = (history = false) => async (dispatch) => {
	await HelixCreationsGetCrqsOnQueueWithErrorRequest(history).then((response) => {
		dispatch(hcGetCrqsOnQueueWithErrorSuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── CREATIONS — CRQs to Create Action ───────────────────────────────────────

export const hcCrqsToCreateAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsToCreateActionRequest());
	await HelixCrqsToCreateActionRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsToCreateActionSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsToCreateActionFailure(error?.message));
	});
};

// ─── CREATIONS — CRQs on Queue with Error Action ─────────────────────────────

export const hcCrqsOnQueueWithErrorAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsOnQueueWithErrorActionRequest());
	await HelixCrqsOnQueueWithErrorActionRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsOnQueueWithErrorActionSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsOnQueueWithErrorActionFailure(error?.message));
	});
};